import { render, staticRenderFns } from "./formSign.vue?vue&type=template&id=0f5b6b36&"
import script from "./formSign.vue?vue&type=script&lang=js&"
export * from "./formSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports